var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { HidePwdIcon, ShowPwdIcon } from '../../icons';
import classNames from '../../utils/classNames';
import styles from './InputField.module.css';
const InputWrapper = (props) => {
    const { canHide, children, hasError } = props;
    const [hide, setHide] = useState(true);
    if (canHide)
        return (_jsxs("div", Object.assign({ className: classNames(styles.pwdInputWrapper, hasError ? styles.hasError : '') }, { children: [React.cloneElement(children, {
                    type: hide ? 'password' : children.props.type,
                    style: { borderBottom: 0 },
                }), _jsx("div", Object.assign({ className: styles.pwdHideIcon, onClick: () => setHide(!hide) }, { children: hide ? _jsx(ShowPwdIcon, { size: 16 }, void 0) : _jsx(HidePwdIcon, { size: 16 }, void 0) }), void 0)] }), void 0));
    return _jsx(_Fragment, { children: children }, void 0);
};
const InputField = (_a) => {
    var { error, customErrorText, name, disabled, className, canHide } = _a, rest = __rest(_a, ["error", "customErrorText", "name", "disabled", "className", "canHide"]);
    return (_jsxs(_Fragment, { children: [_jsx(InputWrapper, Object.assign({ canHide: canHide, hasError: error, disabled: disabled }, { children: _jsx("input", Object.assign({}, rest, { className: classNames(styles.input, className, error ? styles.hasError : ''), name: name, disabled: disabled }), void 0) }), void 0), error ? (_jsx("div", Object.assign({ className: styles.invalidText }, { children: customErrorText ? customErrorText : `Invalid ${name}` }), void 0)) : null] }, void 0));
};
export default InputField;
